import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Params {
	templateId: string;
	stepId: string;
	attachmentId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepHtmlNewsletterAttachmentDeleteMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IHtmlNewsletterAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ templateId, stepId, attachmentId, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.IHtmlNewsletterAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/HtmlNewsletter/${encodeURIComponent(stepId)}/Attachment/${encodeURIComponent(attachmentId)}`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onError,
		onSuccess,
	});
}
